import { TPoints } from '@src/common/types/points';

export function filterPointsByGroup(points: TPoints[], group: Set<string>): TPoints[] {
  return points.filter((item: TPoints): boolean => group.has(item.type));
}
